import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { Link } from 'react-router-dom';
import Clickable from '@prisjakt/ui-clickable';
import { H3Text, TitleSmallText, FontColor } from '@prisjakt/ui/text/variants';
import { TrackingSource } from 'src/areas/expert/components/content-card';

import { trackCategoryPageExpertCarouselInfoList } from './tracking';

import { ExpertCategoryContent } from '../../types';

import * as S from './styles';

type ExtraProps = {
  grid?: boolean;
  numberOfCards?: number;
  hideExperts?: boolean;
  isList?: boolean;
  offset?: number;
};

const MIN_INFO_LIST_COUNT = 5;

const AdvizedContent = ({
  testsCount,
  toplistsCount,
  guidesCount,
  category,
  grid = false,
  toplists,
  tests,
  numberOfCards = 5,
  offset = 0,
  hideExperts = true,
}: ExpertCategoryContent & ExtraProps) => {
  const { linkTo, renderMode, t } = useContext(AppContext);

  if (!category || !(testsCount || toplistsCount || guidesCount)) return null;

  const content = [...(tests || []), ...(toplists || [])];

  const getInfoListItems = () => {
    return [
      toplistsCount ? `${toplistsCount} ${t('expert', 'toplist.lists')}` : null,
      testsCount ? `${testsCount} ${t('expert', 'test.tests')}` : null,
      guidesCount ? `${guidesCount} ${t('expert', 'guide.guides')}` : null,
    ].filter(item => item);
  };

  const showInfoList = (toplistsCount ?? 0) - offset >= MIN_INFO_LIST_COUNT;

  return (
    <>
      <S.Header>
        <H3Text>{t('expert', 'widget.category-page-title')}</H3Text>
        <Link to={linkTo('experts')}>
          <TitleSmallText color={FontColor.PRIMARY}>
            {t('expert', 'widget.category-page-link')}
          </TitleSmallText>
        </Link>
      </S.Header>

      <S.Cards>
        {showInfoList && (
          <S.Card outlined={false}>
            <S.CardActionArea
              container={Clickable}
              containerProps={{
                onClick: () =>
                  trackCategoryPageExpertCarouselInfoList(
                    category.url,
                    'infoList'
                  ),
                to: linkTo(
                  'expertCategory',
                  { semantic_id: category.url },
                  renderMode === 'native' ? { view: 'native' } : undefined
                ),
              }}
            >
              <S.CardBackgroundImage src={category.descriptionImage || ''}>
                <S.CardContent>
                  <S.Description>
                    <span>
                      {t('expert', 'widget.category-page-description', {
                        category: category.name.toLowerCase(),
                      })}
                    </span>
                    <S.InfoList list={getInfoListItems() as string[]} />
                  </S.Description>
                </S.CardContent>
              </S.CardBackgroundImage>
            </S.CardActionArea>
          </S.Card>
        )}

        <S.ContentCards
          offset={offset}
          category={category}
          items={content}
          limit={numberOfCards}
          hideExperts={hideExperts}
          trackingSource={TrackingSource.ADVIZED_WIDGET}
        />
      </S.Cards>
    </>
  );
};

export const AdvizedCarousel = (props: ExpertCategoryContent & ExtraProps) => {
  const { isList = true, grid } = props;
  return isList ? (
    <S.AdvizedListWrapper grid={grid || false}>
      <AdvizedContent {...props} />
    </S.AdvizedListWrapper>
  ) : (
    <S.Wrapper>
      <AdvizedContent {...props} />
    </S.Wrapper>
  );
};
